var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('users-form',{attrs:{"user":_vm.user,"errors":_vm.errors},on:{"update:user":function($event){_vm.user=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }